import {makeStyles} from '@material-ui/core/styles'
import PeopleTab from '../../../components/3modules/AccountImport/PeopleTab'
import {useNavigate, useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import Paper from '@mui/material/Paper'

const ApproveLocationForm = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const id = useParams().id
    const [selectedClient, setSelectedClient] = useState(null)
    const [selectedLocation, setSelectedLocation] = useState(null)

    const onCancel = () => {
        navigate(`/adminDashboard`)
    }

    const onNext = () => {
        navigate(`/approvePeople/people/${id}`)
    }


    useEffect(()=>{
        const selectedClientFromStorage = getItemFromSessionStorage('selectedClient')
        if(selectedClientFromStorage){
            setSelectedClient(selectedClientFromStorage)
        }

        const selectedLocationFromStorage = getItemFromSessionStorage('selectedLocation')
        if(selectedLocationFromStorage){
            setSelectedLocation(selectedLocationFromStorage)
        }


    }, [])

    return (
        <Paper className={classes.root}>
            <PeopleTab onNextPeople={onNext} onCancel={onCancel}
                       selectedClient={selectedClient}
                       setSelectedClient={setSelectedClient}
                       selectedLocation={selectedLocation}
                       setSelectedLocation={setSelectedLocation} disabled
                       importType={"Add new/assign existing contact"} />
        </Paper>
    )
}

export default ApproveLocationForm

const useStyles = makeStyles({
    root: {
        margin: '20px',
        marginLeft: '80px',
        padding: '20px',
        width: '100%'
    }
})
